import { Link } from 'react-router-dom';
import { Loan } from '@/hooks/useSupabaseStore';

const statusConfig = {
  active: { label: 'Đang vay', className: 'bg-emerald-100 text-emerald-700' },
  overdue: { label: 'Quá hạn', className: 'bg-red-100 text-red-700' },
  due_soon: { label: 'Sắp đến hạn', className: 'bg-amber-100 text-amber-700' },
  redeemed: { label: 'Đã chuộc', className: 'bg-gray-100 text-gray-600' },
  forfeited: { label: 'Tịch thu', className: 'bg-purple-100 text-purple-700' },
};

interface Props { loans: Loan[]; }

export default function RecentLoans({ loans }: Props) {
  const recent = loans.slice(0, 6);
  return (
    <div className="bg-white rounded-2xl overflow-hidden">
      <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
        <h3 className="font-bold text-gray-800 text-base">Khoản Vay Gần Đây</h3>
        <Link to="/loans" className="text-[#f59e0b] text-sm font-medium hover:underline cursor-pointer whitespace-nowrap">Xem tất cả</Link>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide">Mã KV</th>
              <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide">Khách hàng</th>
              <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide hidden lg:table-cell">Tài sản</th>
              <th className="text-right px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide">Giá trị</th>
              <th className="text-left px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide hidden xl:table-cell">Hạn trả</th>
              <th className="text-center px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide">Trạng thái</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {recent.map((loan) => {
              const st = statusConfig[loan.status];
              return (
                <tr key={loan.id} className="hover:bg-gray-50/60 transition-colors">
                  <td className="px-5 py-3.5 text-sm font-semibold text-[#f59e0b]">{loan.id}</td>
                  <td className="px-5 py-3.5">
                    <p className="text-sm font-medium text-gray-800">{loan.customerName}</p>
                    <p className="text-xs text-gray-400">{loan.customerPhone}</p>
                  </td>
                  <td className="px-5 py-3.5 text-sm text-gray-600 hidden lg:table-cell max-w-[160px] truncate">{loan.assetName}</td>
                  <td className="px-5 py-3.5 text-sm font-semibold text-gray-800 text-right whitespace-nowrap">{loan.loanAmount.toLocaleString('vi-VN')}đ</td>
                  <td className="px-5 py-3.5 text-sm text-gray-500 hidden xl:table-cell">{loan.dueDate}</td>
                  <td className="px-5 py-3.5 text-center">
                    <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${st.className}`}>{st.label}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
